module.exports = __webpack_public_path__ + "img/icon-msds-file.c465b090.svg";